import Component from '@cell/cell-core/component/component';

import './product-option-selector.scss';

class ProductOptionSelector extends Component {
  constructor() {
    super();

    this.collapsable = this.parsedDataset.collapsable;
    this.collapsableThreshold = this.parsedDataset.collapsableThreshold;

    this.elements = {
      values: this.querySelectorAll('.ProductOptionSelector__Value'),
      expandValuesButton: this.querySelector('.ProductOptionSelector__ExpandValues'),
      collapseValuesButton: this.querySelector('.ProductOptionSelector__CollapseValues'),
    };

    this.handleOptionChange = this.handleOptionChange.bind(this);
    this.handleExpandValues = this.handleExpandValues.bind(this);
    this.handleCollapseValues = this.handleCollapseValues.bind(this);
  }

  componentDidMount() {
    this.on('swatch-button.change', this.handleOptionChange);
    this.on('c-button.click.expand-values', this.handleExpandValues);
    this.on('c-button.click.collapse-values', this.handleCollapseValues);
  }

  handleOptionChange(event) {
    const { value } = event.data;

    // 1. Update selected value.
    // Update the selected option value so the user has additional feedback on which
    // option is currently selected.
    const selectedValueElement = this.querySelector(
      '.ProductOptionSelector__Name .ProductOptionSelector__SelectedValue',
    );

    selectedValueElement.textContent = value;

    // 2. Notify other components.
    this.emit('change', {
      value,
      position: this.parsedDataset.position,
    });
  }

  handleExpandValues() {
    this.elements.values.forEach((value) => {
      value.setAttribute('aria-hidden', 'false');
    });

    this.elements.expandValuesButton.setAttribute('aria-hidden', 'true');
    this.elements.collapseValuesButton.setAttribute('aria-hidden', 'false');
  }

  handleCollapseValues() {
    for (let i = this.collapsableThreshold; i < this.elements.values.length; i++) {
      this.elements.values[i].setAttribute('aria-hidden', 'true');
    }

    this.elements.expandValuesButton.setAttribute('aria-hidden', 'false');
    this.elements.collapseValuesButton.setAttribute('aria-hidden', 'true');
  }
}

customElements.define('product-option-selector', ProductOptionSelector);
